<template>
  <div>
    <!-- 搜索表单 -->
    <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()"
      @submit.native.prevent>
      <el-row :gutter="15">
        <el-col :md="5" :sm="12">
          <el-form-item label="日期:">
            <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="handleDateChange" clearable
              style="width: 270px" />
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12">
          <el-form-item label="年级:">
            <el-select v-model="table.where.gradeId" placeholder="请选择年级" clearable @change="handleChangeGrade">
              <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :md="6" :sm="12">
          <div class="ele-form-actions">
            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
              class="ele-btn-icon">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!-- 操作按钮 -->
    <div class="ele-table-tool ele-table-tool-default">
      <el-button @click="exportInfo" type="primary" icon="el-icon-download" class="ele-btn-icon"
        size="small">导出</el-button>
    </div>
    <ele-data-table ref="table" :config="table" :choose.sync="choose" row-class-name="custom-row-class"
      highlight-current-row>
      <el-table-column type="selection" width="45" align="center" />
      <el-table-column type="index" width="45" align="center" />
      <el-table-column prop="branchName" label="学部" show-overflow-tooltip align="center" />
      <el-table-column prop="gradeName" label="年级" show-overflow-tooltip align="center" />
      <el-table-column prop="className" label="班级" show-overflow-tooltip align="center" />
      <el-table-column prop="rank" label="排名" show-overflow-tooltip align="center">
        <template slot-scope="{ row }"> 第{{ row.rank }}名 </template>
      </el-table-column>
      <el-table-column prop="score" label="总分" show-overflow-tooltip align="center" />
    </ele-data-table>
  </div>
</template>

<script>
import { gradeExportClassStStatistics, getGradeList } from '@/config/yizhongDong/examine';

export default {
  name: 'GradeTotal',
  data () {
    return {
      table: {
        // 表格配置
        url: '/gradeAccess/gradeAccessStatisticsPage',
        method: 'GET',
        where: {
          type: 1
        },
        parseData (res) {
          if (res.resCode == 200) res.code = 0;
          res.count = res.data.total;
          res.data = res.data.records;
          return res;
        },
      },
      choose: [],
      gradeList: [],
      classList: [],
      date: null,
    };
  },
  created () {
    // 获取年级
    this.getGrade(true);
  },
  methods: {
    // 获取年级
    getGrade () {
      getGradeList().then((res) => {
        if (res.data.resCode == 200) {
          this.gradeList = res.data.data || [];
        }
      });
    },
    // 选择年级时
    handleChangeGrade (gradeId) {
      this.table.where.classId = undefined;
      this.classList = [];
      const grade = this.gradeList.find((item) => item.id == gradeId);
      this.table.where.branchId = grade ? grade.branchId : undefined;
      if (gradeId) this.getClass(gradeId);
    },
    // 日期选择
    handleDateChange (value) {
      if (value) {
        this.table.where.startTime = value[0];
        this.table.where.endTime = value[1];
      } else {
        this.table.where.startTime = undefined;
        this.table.where.endTime = undefined;
      }
    },
    // 重置表单
    handleReset () {
      this.table.where = {
        type: 1
      };
      this.date = null;
      this.classList = [];
      this.$refs.table.reload();
    },
    // 导出数据
    exportInfo () {
      gradeExportClassStStatistics(this.table.where).then((res) => {
        let blob = new Blob([res.data], {
          type: 'application/octet-stream',
        });
        let objectUrl = URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = objectUrl;
        let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 下载完成移除元素
        window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
      });
    },
  },
};
</script>

<style scoped></style>
